// ─── KiranaOS product category taxonomy ───────────────────────────────────────
// Single source of truth for product categories, shared by the merchant
// dashboard (StoreOwnerDashboard.js) and the customer storefront
// (CustomerMenuPage.js). Keeping one list here prevents the two screens from
// drifting apart.
//
// CATEGORIES        — canonical merchant-facing labels + display/sort order.
// CATEGORY_ALIASES  — maps already-stored category names (from the seed catalog
//                     CSV or older app versions) onto a canonical display label,
//                     so existing products land on a sensible storefront shelf
//                     WITHOUT any Firestore re-tagging. Display-only.
// getDisplayCategory — resolves a stored category to its display label.
// CATEGORY_FALLBACK_IMAGE — stock image per canonical label, shown only when a
//                     product has no image of its own.

export const CATEGORIES = [
  "Staples & Pantry",
  "Dal & Pulses",
  "Spices & Masala",
  "Oil & Ghee",
  "Fruits & Vegetables",
  "Dairy & Bakery",
  "Breakfast & Instant Food",
  "Biscuits & Snacks",
  "Sweets & Confectionery",
  "Beverages",
  "Frozen Foods",
  "Personal Care",
  "Home Care & Household",
  "Baby Care",
  "Pooja Items",
  "Pet Care",
];

// Stored category name -> canonical display label. Display-only; never written
// back to Firestore. Stored names not listed here (and not already canonical)
// are preserved and shown as their own shelf, appended after CATEGORIES.
export const CATEGORY_ALIASES = {
  "Fresh Produce":        "Fruits & Vegetables",
  "Home Care & Utility":  "Home Care & Household",
  "Grocery & Household":  "Home Care & Household",
  "Snacks & Confectionery": "Biscuits & Snacks",
};

export function getDisplayCategory(category) {
  if (!category) return category;
  return CATEGORY_ALIASES[category] || category;
}

export const CATEGORY_FALLBACK_IMAGE = {
  "Staples & Pantry":         "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400",
  "Dal & Pulses":             "https://images.unsplash.com/photo-1612257999756-a3a24d1b7d0c?w=400",
  "Spices & Masala":          "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400",
  "Oil & Ghee":               "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400",
  "Fruits & Vegetables":      "https://images.unsplash.com/photo-1610348725531-843dff563e2c?w=400",
  "Dairy & Bakery":           "https://images.unsplash.com/photo-1550583724-b2692b85b150?w=400",
  "Breakfast & Instant Food": "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400",
  "Biscuits & Snacks":        "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=400",
  "Sweets & Confectionery":   "https://images.unsplash.com/photo-1481391319762-47dff72954d9?w=400",
  "Beverages":                "https://images.unsplash.com/photo-1544145945-f90425340c7e?w=400",
  "Frozen Foods":             "https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=400",
  "Personal Care":            "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=400",
  "Home Care & Household":    "https://images.unsplash.com/photo-1585421514738-01798e348b17?w=400",
  "Baby Care":                "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400",
  "Pooja Items":              "https://images.unsplash.com/photo-1606293926075-69a00dbfde81?w=400",
  "Pet Care":                 "https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?w=400",
};
